<jsg-sticky-toolbar [class]="outage.mode">
  <div left-bar>
    <div fxLayout="row" fxLayoutAlign="start center" class="outage-block">
      <mat-icon>{{ outage.icon }}</mat-icon>
      <p>
        <span [innerHTML]="outage.description | safeHtml"></span>
        <a
          style="text-decoration: underline; cursor: pointer"
          (click)="viewReleaseNotes.emit()"
          *ngIf="outage.type == 'release'"
          >View release notes</a
        >
      </p>
    </div>
  </div>
  <div right-bar fxLayout="row">
    <button mat-icon-button (click)="dismiss.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</jsg-sticky-toolbar>
